export default __webpack_public_path__ + "static/media/services_bg_blue.2c678542.png";